import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SectionHead, FadeUp } from "@/components/Reveal";
import { CAPABILITIES } from "@/lib/content";

export default function Capabilities() {
  return (
    <section className="relative py-24 sm:py-32 border-t border-white/5" data-testid="capabilities-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHead
          eyebrow="Explore all capabilities"
          title="Your dot stays green, everywhere"
        >
          Discover how the zero-installation engine integrates with your favorite remote work tools and operating
          systems to keep your presence perfectly active.
        </SectionHead>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
          {CAPABILITIES.map((group, gi) => (
            <FadeUp key={group.title} delay={gi * 0.1} className="h-full">
              <div data-testid={`capability-group-${gi}`} className="h-full rounded-2xl border border-white/5 bg-surface p-8">
                <h3 className="font-display font-bold text-lg text-white tracking-tight pb-5 border-b border-white/5">
                  {group.title}
                </h3>
                <ul className="mt-6 space-y-1">
                  {group.items.map((item) => (
                    <li key={item}>
                      <Link
                        to={group.to}
                        data-testid={`capability-link-${item.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                        className="group/link flex items-center justify-between gap-4 py-2.5 text-mist hover:text-neon transition-colors"
                      >
                        <span className="text-[15px]">{item}</span>
                        <ArrowUpRight
                          size={15}
                          className="opacity-0 -translate-x-1 translate-y-1 group-hover/link:opacity-100 group-hover/link:translate-x-0 group-hover/link:translate-y-0 transition-all duration-200 text-neon shrink-0"
                        />
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
